module.exports = __webpack_public_path__ + "static/digital1071d3fdd8238866f2e73c5a4fbc4f957.png";